<!-- Translated: yes -->
<template>
  <button
    v-ripple
    :class="[
      'component',
      'outline-button',
      active && 'active',
      label && 'has-text'
    ]"
    @click="$emit('click')"
  >
    <icon v-if="icon" :name="icon" :scale="iconscale"></icon>
    <span v-if="label">{{ label }}</span>
  </button>
</template>

<script>
export default {
  props: {
    label: {},
    icon: {},
    active: {},
    iconscale: {
      type: Number,
      default: 1,
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/global.styl'

.component
  button-reset()
  display: inline-block
  background white
  border 1px solid light-blue
  color deep-blue
  border-radius 4px
  text-transform uppercase
  padding 0.4rem 0.4rem 0.2rem 0.4rem
  line-height 1em
  font-weight bold
  font-size 11px
  transition-ease()
  &:hover
    border-color alpha(deep-blue, .5)
    border-bottom-width: 1px
    background-color: light-blue-grey
    color #005580
  &:focus
    outline 1px solid rgba(0, 85, 128, 0.1)
    border-color deep-blue
  &.active
    background-color deep-sea-blue
    border solid 1px light-blue-grey
    color white
  &.has-text
    .icon
      position: relative;
      top: -2px
      margin-right: 5px

</style>



// WEBPACK FOOTER //
// OutlineButton.vue?c1c118b6